module.exports = __webpack_public_path__ + "static/media/Service-Communication-Monitor_S.edda581f.jpg";